// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__XO_oY","footer":"ModalInfo_footer__2dwYG"};